module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated-dots"
  }, [_c('lottie', {
    attrs: {
      "options": _vm.defaultOptions,
      "height": 34,
      "width": 35
    },
    on: {
      "animCreated": _vm.handleAnimation
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4573a526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dots.vue
// module id = 211
// module chunks = 0 1